<template>
    <b-nav-item-dropdown menu-class="nav-menu locale-dropdown-menu" right>
      <template v-slot:button-content>
        🌐 {{$i18n.locale}}
      </template>
      <b-dropdown-item @click="setLocale('en')">English</b-dropdown-item>
      <b-dropdown-item @click="setLocale('es')">Española</b-dropdown-item>
      <b-dropdown-item @click="setLocale('de')">Deutsch</b-dropdown-item>
      <b-dropdown-item @click="setLocale('fr')">Français</b-dropdown-item>
      <b-dropdown-item @click="setLocale('el')">Ελληνικά</b-dropdown-item>
      <b-dropdown-item @click="setLocale('nl')">Nederlands</b-dropdown-item>
      <b-dropdown-item @click="setLocale('ru')">Русский</b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
import { loadLanguageAsync } from '../i18n'

export default {
  methods: {
    setLocale (locale) {
      // this.$i18n.locale = locale
      loadLanguageAsync(locale)
    }
  }
}
</script>

<style>
.locale-dropdown-menu {
  min-width: auto;
}
</style>
